import React from "react";
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import {BreadcrumbItem, Breadcrumb} from 'react-bootstrap';
import { Link } from 'react-router-dom';
import JotFormComponent from '../Component/JotFormComponent';

const BookSession = () =>{
  
  return (
    <div className="BookSession">
    
    <section className="inner-banner banner-align">
      <img className="img-fluid" src={process.env.PUBLIC_URL + "/assets/img/innerbanner/book-one-on-one.jpg"} alt="Book one on one session"/>
    </section>
    <section  className="research-box-area">
         <Container>
         <Breadcrumb>
                <BreadcrumbItem>
                  <Link as={Link} to="/">
                         Home
                  </Link>
                </BreadcrumbItem>
                <BreadcrumbItem>
                  <Link as={Link} to="/research-support">
                  Research Support
                  </Link>
                </BreadcrumbItem>
                <BreadcrumbItem active>Book ‘one on one’ session</BreadcrumbItem>
              </Breadcrumb>
         
            <div className='information-content'>
              <h2>Book ‘one on one’ session</h2>
              <p>Our professional staff is available to assist students, faculty and staff for in-depth consultations. You may make an appointment with one of our library team members. You can schedule a meeting by submitting a request form below or click here for further support.</p>
              <JotFormComponent />
            </div>
         </Container>
    </section>
   
  </div>
  );
}
export default BookSession;